<section class="check-ins" aria-labelledby="check-ins-title">
  <h2 id="check-ins-title" class="check-ins__title">Ownership History</h2>

  @if (isLoading()) {
    <div class="check-ins__loading">
      <lib-new-loading></lib-new-loading>
    </div>
  } @else if (errorMessage()) {
    <p class="check-ins__message" role="status">
      {{ errorMessage() }}
    </p>
  } @else {
    @let items = checkIns();

    @if (items.length > 0) {
      <div class="check-ins__list">
        @for (item of items; track item.id) {
          <article class="check-ins__item">
            <header class="check-ins__item-header">
              @if (allowOwnerNavigation() && item.petszelOwnerId) {
                <button
                  type="button"
                  class="check-ins__owner-link"
                  [attr.aria-label]="
                    'View ' + item.ownerName + ' pet parent profile'
                  "
                  (click)="onViewOwner(item.petszelOwnerId)"
                >
                  {{ item.ownerName }}
                </button>
              } @else {
                <h3 class="check-ins__owner-name">
                  {{ item.ownerName }}
                </h3>
              }

              <span
                class="
                  check-ins__status
                  {{ item.statusClass }}
                "
              >
                {{ item.status }}
              </span>
            </header>

            @if (isAdopterUnknown(item)) {
              <div class="petszel-warning-alert">
                <div class="petszel-warning-alert__icon">
                  <lib-icon iconName="utilityWarningIcon"></lib-icon>
                </div>
                <div class="petszel-warning-alert__content">
                  This adopter did not opt in to post-adoption support at checkout. Please refer to the knowledge base article <a
                  href="https://support.petszel.com/en-us/sheltersupport/how-do-i-update?hs_preview=PcbZXWLs-188752473110" target="_blank">here</a> to update this record.
                </div>
              </div>
            }

            <dl class="check-ins__events">
              <div class="check-ins__events__owner-details">
                <div class="check-ins__events__owner-details__left">
                  <span><strong>Petszel ID:</strong></span>
                  <span>{{ item.petszelOwnerId }}</span>
                </div>

                <div class="check-ins__events__owner-details__right">
                  @if (surveySubmissionsFormatted()) {
                    <lib-check-ins-summary [checkInsSummary]="getCheckInsByOwner(item.petszelOwnerId)">
                    </lib-check-ins-summary>
                  }
                </div>

              </div>

              <div class="check-ins__events__details">
                <table class="table table-sm table-borderless">
                  <thead>
                    <tr>
                      <th scope="col">Event</th>
                      <th scope="col">Event Date (CST)</th>
                      <th scope="col">Sub Event</th>
                      @if (isStaff()) {
                        <th scope="col">Created Date (CST)</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (e of item.eventsFormatted; track $index) {
                      <tr>
                        <td>{{ e.event }}</td>
                        <td>{{ e.eventDate }}</td>
                        <td>{{ e.subEvent }}</td>
                        @if (isStaff()) {
                          <td>{{ e.createdDate }}</td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>

            </dl>
          </article>
        }
      </div>
    } @else {
      <p class="check-ins__message">No ownership history available.</p>
    }
  }
</section>
